import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SmoothScroll } from "./SmoothScroll";
import { Nav } from "./Nav";
import { Contact } from "./Contact";

export const BeforeAfter = ({ before, after }) => (
  <div className="my-8 grid gap-3 sm:grid-cols-2" data-testid="before-after-example">
    <div className="rounded-2xl border border-white/10 bg-[var(--navy)] p-5">
      <p className="font-mono-d text-[11px] uppercase tracking-[0.2em] text-slate-400">Before</p>
      <p className="mt-2 text-slate-300 line-through decoration-white/20">{before}</p>
    </div>
    <div className="rounded-2xl border border-[var(--teal)]/40 bg-[var(--navy-2)] p-5">
      <p className="font-mono-d text-[11px] uppercase tracking-[0.2em] text-[var(--teal)]">After</p>
      <p className="mt-2 text-white">{after}</p>
    </div>
  </div>
);

export const OrderCta = ({ text = "Want us to rewrite yours?" }) => (
  <div className="mt-14 flex flex-col gap-5 rounded-3xl bg-[var(--teal)] p-8 text-[var(--ink)] sm:flex-row sm:items-center sm:justify-between">
    <div>
      <p className="font-serif-d text-4xl leading-none">{text}</p>
      <p className="mt-2 text-[var(--ink)]/80">Real numbers, your keywords, Word + PDF. From $75.</p>
    </div>
    <Link to="/#pricing" data-testid="subpage-order-cta"
      className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-[var(--ink)] px-6 py-3.5 font-semibold text-[var(--teal)] transition-transform hover:scale-[1.03]">
      See plans <ArrowUpRight className="h-4 w-4" />
    </Link>
  </div>
);

export const Subpage = ({ children }) => (
  <SmoothScroll>
    <div className="relative min-h-screen overflow-x-clip bg-[var(--ink)]">
      <Nav />
      <main className="mx-auto max-w-3xl px-5 pb-10 pt-36 sm:px-8 sm:pt-44">{children}</main>
      <Contact />
    </div>
  </SmoothScroll>
);
